import 'styles/global.scss'
import 'styles/flex.scss'
import 'styles/position.scss'
import 'styles/overflow.scss'
import 'styles/border.scss'
import 'styles/background.scss'
import 'styles/padding.scss'
import 'styles/cursor.scss'
import 'styles/width.scss'
import 'styles/margin.scss'
import 'styles/button.scss'
import 'styles/anchors.scss'
import 'styles/typography.scss'
import 'styles/display.scss'

export const onRouteUpdate = ({ location }) => {
    window.dispatchEvent(new Event('navigate'))
    const { hash } = location
    const el = hash ? document.querySelector(hash) : null
    if (el) window.requestAnimationFrame(() => window.scrollTo(0, el.offsetTop))
}

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition, }) => {
    const savedScrollPosition = getSavedScrollPosition(location)
    window.requestAnimationFrame(() => window.scrollTo(...savedScrollPosition))
    return false
}
